orders-planner-line
  .back-col
    span &nbsp;
  .dates-col
    orders-planner-line-calendar(tag-scope="orders_planner")
    orders-planner-schedules(tag-scope="{dataScopeLine(opts.id)}")
    orders-planner-deadline(tag-scope="{dataScopeOrder(opts.order_id)}")
  .forward-col
    span &nbsp;
  script(type="typescript").
    this.mixin('orders.planner.line');
